import React from "react";
import Page from "../../components/Page";
import { EmailInput, PasswordInput, NameInput } from "../../components/common";
import { useState, useEffect } from "react";
import { url } from "../../url";
import { useNavigate } from 'react-router-dom'
import axios from "axios";
import styles from "./register.module.scss"

const Register = () => {
  // Data 
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')

  // Errors
  const [usernameError, setUsernameError] = useState('') 
  const [emailError, setEmailError] = useState('')
  const [passwordError, setPasswordError] = useState('')

  const navigate = useNavigate()

  const signUp =  async (username: string, email: string, password: string) => {
    const registerData = {
      username: username,
      email: email,
      password:  password
    }
    let response;
    try {
      response = await axios.post(
      url + `/auth/signup`, 
      registerData,
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
    } catch (error: any) {
      response = error.response
      console.log(response)
    }

    return response.data
  }

  const signUpClick = async () => {
    setEmailError('')
    setPasswordError('')
    setUsernameError('')
  
    if ('' === username) {
      setUsernameError('Please enter a username')
      return
    }

    if ('' === email) {
      setEmailError('Please enter your email')
      return
    }
  
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setEmailError('Please enter a valid email')
      return
    }
  
    if ('' === password) {
      setPasswordError('Please enter a password')
      return
    }

    if (password.length < 8) {
      setPasswordError('Password must be at least 8 characters')
      return
    }

    if (password !== repeatPassword) {
        setPasswordError('Passwords are not the same')
        return
    }

    const responseData =  await signUp(username, email, password)
    console.log(responseData)
    if (responseData.message == "Email is already taken") {
      setEmailError('Email is already taken')
      return
    }
    else if (responseData.message == "Username is already taken") {
      setPasswordError('Username is already taken')
      return
    }
    else {
      navigate("/login")
    }

  }
  useEffect(() => {
    if (localStorage.getItem('token')) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <Page>
      <section className={styles.homeBox}>
      <div className={styles.box}>
          <div className={styles.nameBox}>
            <p className={styles.nameBox__welcome}>Welcome to</p>
            <h2 className={styles.nameBox__brandName}>
              Slinge<span>rr</span>
            </h2>
          </div>
          <div className={styles.logSigBox}>
            <NameInput
            name={username}
            setName={setUsername}
            label="Username"
            />
            <label className={styles.logSigBox__error}>{usernameError}</label>
            <EmailInput
            email={email}
            setEmail={setEmail}
            />
            <label className={styles.logSigBox__error}>{emailError}</label>
            <PasswordInput
            password={password}
            setPassword={setPassword}
            />
            <PasswordInput
            password={repeatPassword}
            setPassword={setRepeatPassword}
            label="Confirm password"
            />
            <label className={styles.logSigBox__error}>{passwordError}</label>
            <div className={styles.logSigBox__btns}>
              <button  className={styles.logSigBox__logInBtn}
              onClick={signUpClick}
              >
                Sign Up
              </button>
              <p className={styles.logSigBox__noAccountText}>Already have an account?</p>
              <div className={styles.underline}></div>
              <button  className={styles.logSigBox__logInBtn}
              onClick={() => navigate('/login')}
              >
              Sign in
              </button>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default Register;
